import { Link } from "react-router-dom";
import { useGetBlogQuery } from "../../../../Redux/Apis/blogApi";
import { fa_dateـetime } from "../../../../utils/PersianNum";

function Blog({name,caption,site_id}) {
    const {data , isLoading } = useGetBlogQuery(site_id)

    return ( 
        <div className="latest-news mt-150 mb-150">
            <div className="container">
                <div className="row">
                {
                    isLoading ? "در حال بارگذاری" :
                    data && data.map((row,index) => 
                    <div className="col-lg-4 col-md-6" key={index}>
                        <div className="single-latest-news">
                            <Link to={`/post/${row.id}`}>
                                <div className="latest-news-bg" style={{backgroundImage: `url(${row.image})`}}></div>
                            </Link>
                            <div className="news-text-box">
                                <h3><Link to={`/post/${row.id}`}>
                                    {row.title}
                                </Link></h3>
                                <p className="blog-meta">
                                    <span className="author"><i className="fas fa-user"></i>مدیر</span>
                                    <span className="date"><i className="fas fa-calendar"></i>{fa_dateـetime(row.create_date)}</span>
                                </p>
                                <p className="excerpt">{row.excerpt}</p>
                                <Link to={`/post/${row.id}`} className="read-more-btn"><i className="fas fa-angle-left mr-1"></i>مشاهده کامل</Link>
                            </div>
                        </div>
                    </div>
                    )}
                </div>

                
            </div>
        </div>
    );
}

export default Blog;